document.documentElement.classList.add('wyniki-js-pending');window.pewniakiWynikiStartTimer=window.setTimeout(function(){document.documentElement.classList.remove('wyniki-js-pending');},3000);
